<div
  class="skip-link-container d-none d-lg-block"
  [cxFocus]="{ tab: true }"
  *ngIf="skipLinks$ | async as links"
>
  <button
    *ngFor="let link of links"
    (click)="scrollToTarget(link)"
    [attr.data-qa]="'skip-link-' + link.i18nKey"
    class="btn btn-secondary skip-link-button"
  >
    <span>{{ link.i18nKey | cxTranslate }}</span>
    <app-svg dimension="1rem" iconName="ArrowBig" [rotate]="180"></app-svg>
  </button>
</div>
